import React, { useEffect, useState } from 'react';
import { Form, Layout, Typography } from 'antd';
import RootLayout from '../../layout/Layout';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import Cookies from 'js-cookie';
import axios from 'axios';
import { createMenuList } from '../../constants';
import './style.less';
import { useDispatch, useSelector } from 'react-redux';
import { addForm, addFormFromTemplate, addGoogleForm } from '../../store/actions/formActions';
import CreateForm from '../../components/CreateForm';
import Icon, { ArrowLeftOutlined } from '@ant-design/icons';
import TemplateCards from '../../components/TemplateCards';
import NotFound from '../../pages/NotFound/NotFound';

import NProgress from 'nprogress';
import { useTranslation } from 'react-i18next';

const CreateCard = ({ item, select, current, onCreateClick, me }) => {
  const { t } = useTranslation();
  const { error } = useSelector((state) => state.form);

  const onSelect = async (type) => {
    try {
      select(type);
      if (type === 'new') return onCreateClick(type);
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <div
      className={`card ${current === item?.type && 'active'}`}
      onClick={() => onSelect(item.type)}
    >
      <div>
        <img src={item.icon} />
      </div>
      <div className="card-text-container">
        <h4 className="card-title">{t(`createType.${item.title}`)}</h4>
        <p className="card-desc">{t(`createType.${item.desc}`)}</p>
      </div>
    </div>
  );
};

const Create = () => {
  const [selectedMenu, setSelectedMenu] = useState('');
  const [step, setStep] = useState(0);
  const [convertForm, setConvertForm] = useState({});
  const [templateId, setTemplateId] = useState('');
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const { me } = useSelector((state) => state.auth);

  const [form] = Form.useForm();
  const [whatsappNumber, setWhatsappNumber] = useState(
    me.whatsappNumber || localStorage.getItem('wfNumber') || '',
  );
  const [createLoading, setCreateLoading] = useState(false);

  const [createTemplateId] = useState(Cookies.get('templateId'));

  // clear templateId from localstorage on unmount
  useEffect(() => {
    return () => {
      Cookies.remove('templateId', { domain: '.whatsform.com' });
    };
  }, []);

  const handleSelect = (val) => {
    setTemplateId('');
    setConvertForm({});
    setSelectedMenu(val);
  };

  const onNextClick = () => {
    // if there is templateId in localstorage, create form from here
    if (createTemplateId) {
      setCreateLoading(true);
      const formData = form.getFieldsValue();
      dispatch(
        addFormFromTemplate({
          templateId: createTemplateId,
          number: formData.number.slice(),
        }),
      ).then((form) => {
        setCreateLoading(false);
        finishConvertForm(form);
      });
      return;
    }
    // else go to next step
    setStep(1);
  };

  const onCreateClick = (type, convertForm) => {
    setCreateLoading(true);
    NProgress.start();
    const formData = form.getFieldsValue(true);
    if (!isEmpty(formData)) {
      if (type === 'new') {
        return dispatch(
          addForm({
            name: 'Untitled',
            language: formData.language,
            whatsappNumber: formData.number,
          }),
        ).then((form) => {
          setCreateLoading(false);
          NProgress.done();
          finishConvertForm(form);
        });
      }

      if (type === 'template') {
        return dispatch(
          addFormFromTemplate({
            templateId: convertForm.templateId,
            number: formData.number,
          }),
        ).then((form) => {
          setCreateLoading(false);
          NProgress.done();
          finishConvertForm(form);
        });
      }
    }
  };

  const finishConvertForm = (item) => {
    if (item && item.id) {
      return history.push(`/forms/${item.id}/build`);
    }
  };

  const handleSetConvertForm = (form) => {
    setConvertForm(form);
  };

  const goBack = () => {
    if (step === 1) {
      setSelectedMenu('');
      return setStep(0);
    }
    history.push('/');
  };

  const setView = () => {
    switch (step) {
      case 0:
        return (
          <CreateForm
            form={form}
            whatsappNumber={whatsappNumber}
            setWhatsappNumber={setWhatsappNumber}
            loading={createLoading}
            createTemplateId={createTemplateId}
            onSubmit={onNextClick}
          />
        );

      case 1:
        return (
          <>
            <div className="option-container">
              {createMenuList.map((menuItem, i) => (
                <CreateCard
                  key={i}
                  item={menuItem}
                  select={handleSelect}
                  current={selectedMenu}
                  onCreateClick={onCreateClick}
                  me={me}
                />
              ))}
            </div>
            {selectedMenu === 'template' && (
              <TemplateCards
                selectedTemplate={templateId}
                setTemplate={setTemplateId}
                onCardClick={onCreateClick}
                language={form.getFieldValue('language')}
              />
            )}
          </>
        );
      default:
        return <NotFound />;
    }
  };

  const setHeading = () => {
    switch (step) {
      case 0:
        return <Typography.Title className="title">{t('create.title')}</Typography.Title>;

      case 1:
        return (
          <Typography.Title className="title">
            {t('create.subTitle', 'How would you like to start?')}
          </Typography.Title>
        );
      default:
        return <Typography.Title className="title">{t('create.title')}</Typography.Title>;
    }
  };

  return (
    <RootLayout>
      <div className="Create">
        <Layout className="container">
          <div className="create-form-header">
            <Icon component={ArrowLeftOutlined} className="back-icon" onClick={goBack} />
            {setHeading()}
          </div>
          {setView()}
        </Layout>
      </div>
    </RootLayout>
  );
};

export default Create;
